var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vorteilsclub-page__header"},[_c('span',{staticClass:"font-extrabold"},[_vm._v("Ihre VN-Vorteile")]),_vm._v(" "),_c('DropDown',{attrs:{"options":_vm.categories,"value":_vm.current},on:{"input":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }